import { useQuery } from "@tanstack/react-query";
import { getApp } from "firebase/app";
import { collection, getDoc, getDocs, getFirestore } from "firebase/firestore";
import { func } from "prop-types";
import { COURSE_CATEGORY_COLLECTION } from "src/constants/collectionsIds";

export default function useGetCourseCategories() {
  return useQuery({
    queryKey: ["course-categories"],
    queryFn: async () => {
      const app = getApp();
      const db = getFirestore(app);
      const courseCategoriesColRef = collection(db, COURSE_CATEGORY_COLLECTION);
      const courseCategoriesSnapshot = await getDocs(courseCategoriesColRef);
      if (courseCategoriesSnapshot.empty) return { categories: [] };
      const courseCategories = courseCategoriesSnapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      return {
        categories: courseCategories,
      };
    },
  });
}
